import ManagementSide from "./ManagementSide";

export default ManagementSide;